import crm from './crm';

const ModuloService = {
  buscarModulosPorClienteUsuario: () => {
    return crm.get(`/modulos`);
  }
};

export default ModuloService;
